document.addEventListener('DOMContentLoaded', () => {
  const pdpUpsellPopup = document.querySelector('.pdp-upsell-popup');

  const upsellPopupTrigger = document.querySelectorAll('.upsell-popup-trigger');
  const upsellPopupForm = document.querySelector('.pdp-upsell-popup__submit');
  let pendingButtonClick = null;
  let clickHandler = null;

  upsellPopupTrigger.forEach(trigger => {
    clickHandler = (event) => {
      const isTriggerOrChild = event.target.closest('.upsell-popup-trigger') === trigger;
      if (!isTriggerOrChild) return;

      event.preventDefault();
      pdpUpsellPopup.querySelector('.pdp-upsell-popup__product-title.mobile').textContent = trigger.dataset.productTitle;
      pdpUpsellPopup.querySelector('.pdp-upsell-popup__product-title.desktop').textContent = trigger.dataset.productTitle;
      pdpUpsellPopup.querySelector('.pdp-upsell-popup__image').innerHTML = `<img src="${window.location.origin}/cdn/shop/${trigger.dataset.productImage}" alt="${trigger.dataset.productTitle}" />`;
      pdpUpsellPopup.querySelector('.price-block__price').innerHTML = trigger.dataset.productPrice;
      trigger.dataset.productComparePrice ? pdpUpsellPopup.querySelector('.price-block__compare-price').innerHTML = trigger.dataset.productComparePrice : pdpUpsellPopup.querySelector('.price-block__compare-price').innerHTML = '';
      trigger.dataset.productSubtitle ? pdpUpsellPopup.querySelector('.pdp-upsell-popup__subtitle').textContent = trigger.dataset.productSubtitle : pdpUpsellPopup.querySelector('.pdp-upsell-popup__subtitle').textContent = '';
      trigger.dataset.productUpsellTitle ? pdpUpsellPopup.querySelector('.pdp-upsell-popup__title').textContent = trigger.dataset.productUpsellTitle : pdpUpsellPopup.querySelector('.pdp-upsell-popup__title').textContent = '';
      pdpUpsellPopup.querySelector('.pdp-upsell-popup__submit').dataset.id = trigger.dataset.productId;
      pendingButtonClick = trigger;
      pdpUpsellPopup.classList.add('active');
      document.body.classList.add('overflow-hidden');
    };
    trigger.addEventListener('click', clickHandler);
  });
  
  const closeBtn = pdpUpsellPopup.querySelector('.pdp-upsell-popup__close-btn');

  const closePopup = () => {
    pdpUpsellPopup.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    if (pendingButtonClick) {
      pendingButtonClick.classList.remove('upsell-popup-trigger');
      pendingButtonClick.removeEventListener('click', clickHandler);
      pendingButtonClick.click();
      pendingButtonClick.classList.add('upsell-popup-trigger');
      pendingButtonClick = null;
    }
  };
  
  closeBtn.addEventListener('click', closePopup);

  pdpUpsellPopup.addEventListener('click', (event) => {
    const isWrapperOrChild = event.target.closest('.pdp-upsell-popup__wrapper');
    if (!isWrapperOrChild && event.target === pdpUpsellPopup) {
      closePopup();
    }
  });

  upsellPopupForm.addEventListener('click', (event) => {
    const qnt = document.querySelector('.pdp-upsell-popup__form .quantity__input').value;

    let formData = {
      'items': [{
        'id': upsellPopupForm.dataset.id,
        'quantity': qnt
      }]
    };
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      pdpUpsellPopup.classList.remove('active');
      document.body.classList.remove('overflow-hidden');

      if (pendingButtonClick) {
        pendingButtonClick.classList.remove('upsell-popup-trigger');
        pendingButtonClick.removeEventListener('click', clickHandler);
        pendingButtonClick.click();
        pendingButtonClick.classList.add('upsell-popup-trigger');
        pendingButtonClick = null;
      }

      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  });
});